<template>
  <div>
    <List
      v-if="!isLoading"
      listing="customer"
      :fields="fields"
      search-text="Rechercher un client"
      :pageSize="pageSize"
      edit-route-name="customer-edit"
    >
      <template v-slot:buttons>
        <div class="md:flex flex-row justify-around hidden md:w-1/3">
          <button
            type="button"
            class="twn-button whitespace-no-wrap overflow-hidden text-xs mr-2"
            @click="onAddCustomerClick"
          >
            Ajouter un nouveau client
          </button>
        </div>
      </template>
    </List>
  </div>
</template>

<script>
  import List from "@/components/List";
  import { mapActions } from "vuex";

  export default {
    components: {
      List,
    },
    props: {
      pageSize:{
        type: Number,
        default: 30,
        required: false
      }
    },
    data: () => ({
      isLoading: true,
      fields: [
        {
          key: "identifier",
          label: "Identifiant",
          sortable: true,
        },
        {
          key: "name",
          label: "Nom",
          sortable: true,
        },
        {
          key: 'managers',
          label: 'Responsables',
          sortable: true,
          db: `managers {
            user {
              first_name
              last_name
            }
          }`,
          formatter: (managers) => {
            if (!managers)
              return 'Aucun'

            return managers.map((manager) => [manager.user.first_name, manager.user.last_name].filter(str => str || false).join(' ') || '~ Utilisateur supprimé ~').join(', ')
          }
        },
        {
          key: 'groups_aggregate',
          label: 'Promotions',
          sortable: true,
          db: `groups_aggregate {
            aggregate {
              count
            }
          }`,
          nested: 'count'
        },
        {
          key: 'groups.users_aggregate',
          label: 'Stagiaires',
          sortable: true,
          db: `groups {
            users_aggregate {
              aggregate {
                count
              }
            }
          }`,
          formatter: (value, key, item) => {
            if (!item.groups)
              return 0

            return item.groups.reduce((count, group) => (count + group.users_aggregate.aggregate.count), 0)
          }
        },
        {
          label: 'Actifs',
          sortable: true,
          key: 'activeGroups',
          db: `activeGroups: groups {
            users_aggregate(where: {user: {cognito_confirmed: {_eq: true}}}) {
              aggregate {
                count
              }
            }
          }`,
          formatter: (value, key, item) => {
            if (!item.activeGroups)
              return 0

            return item.activeGroups.reduce((count, group) => (count + group.users_aggregate.aggregate.count), 0)
          }
        },
        {
          label: 'Niv 1 terminé',
          sortable: true,
          key: 'groups.level1',
          db: `groups {
            level1: users_aggregate(where: {user: {user_logs: {type: {slug: {_eq: "course"}}, data_key: {_eq: "LVL_UUID"}}}}) {
              aggregate {
                count
              }
            }
          }`,
          formatter: (value, key, item) => {
            if (!item.groups)
              return 0

            return item.groups.reduce((count, group) => (count + group.level1.aggregate.count), 0)
          }
        },
        {
          label: 'Niv 2 terminé',
          sortable: true,
          key: 'groups.level2',
          db: `groups {
            level2: users_aggregate(where: {user: {user_logs: {type: {slug: {_eq: "course"}}, data_key: {_eq: "LVL_UUID"}}}}) {
              aggregate {
                count
              }
            }
          }`,
          formatter: (value, key, item) => {
            if (!item.groups)
              return 0

            return item.groups.reduce((count, group) => (count + group.level2.aggregate.count), 0)
          }
        }
      ]
    }),
    async mounted() {
      this.isLoading = true

      const level1 = await this.$store.dispatch('Course/GetCourseIDByType', 'mission')
      const level2 = await this.$store.dispatch('Course/GetCourseIDByType', 'investigation')

      if (level1) {
        this.fields[this.fields.length - 2].db = this.fields[this.fields.length - 2].db.replace('LVL_UUID', level1)
      }

      if (level2) {
        this.fields[this.fields.length - 1].db = this.fields[this.fields.length - 1].db.replace('LVL_UUID', level2)
      }

      this.isLoading = false
    },
    methods: {
      ...mapActions("EditItem", ["clearCurrentID"]),
      onAddCustomerClick() {
        this.clearCurrentID();
        this.$router.push({ name: "customer-create" });
      },
    },
  };
</script>